import { Injectable } from "@angular/core";
import { HttpClient, HttpRequest } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";
import { AdminViewModel } from "src/app/models/AdminViewModel";

@Injectable({
    providedIn: 'root'
})
export class ShippingLineService {
  private _jsonURL = 'assets/localdb/shippingLines.json';
  public baseurl = environment.apiUrl;
  private uploadApi = "api/Upload/";
  private shippingLineApi = "api/ShippingLine";

  constructor(private http: HttpClient) {
    // this.getJSON().subscribe(data => console.log(data));
  }

  public getJSON(): Observable<any> {
    return this.http.get(this._jsonURL);
  }

  GetShippingLinesList(data) {
    const url = this.baseurl + this.shippingLineApi + '?' + this.GetShippingLineListParameters(data);
    return this.http.get(url, data);
}

GetShippingLineDetails(id) {
    const url = this.baseurl + this.shippingLineApi + '/' + id;
    return this.http.get(url);
}
UpdateShippingLine(data) {
    const url = this.baseurl + this.shippingLineApi;
    return this.http.put(url, data);
}

AddShippingLine(data) {
    const url = this.baseurl + this.shippingLineApi;
    return this.http.post(url, data);
}


private GetShippingLineListParameters(data: AdminViewModel) {
  let url = "";
  if (data.pageNo) {
      url = url + `pageNo=${data.pageNo}`
  }
  if (data.pageSize) {
      url = url + `&pageSize=${data.pageSize}`
  }
  if (data.searchText) {
      url = url + `&searchText=${data.searchText}`
  }
  if (data.sort) {
      url = url + `&sort=${data.sort}`
  }
  if (data.columnName) {
      url = url + `&columnName=${data.columnName}`
  }
  if (data.regionId) {
      url = url + `&regionId=${data.regionId}`
  }
  if (data.countryId) {
      url = url + `&countryId=${data.countryId}`
  }
  if (data.shippinglineId) {
      url = url + `&shippinglineId=${data.shippinglineId}`
  }
  return url;
}

}